import { ArrowRight } from "lucide-react";
import ArrowLink from "../components/arrow-link";
import { CriminalViolationsList } from "../components/criminal-violations-list";
import { StatusIndicatorRow } from "../components/status-indicator-row";
import "./verification.css";
import bookingVideo from "../assets/images/booking.mp4";
import gradientRect from "../assets/images/gradient-rect.png";
import licenseImage from "../assets/images/license.png";
import mvrReportImage from "../assets/images/mvr-report.png";
import verifyRequestImage from "../assets/images/verify-request.png";

export const verificationData = [
  {
    heading: "Identification & Biometrics",
    subHeading:
      "Verify every renter's identity with instant ID and selfie verification.",
    verificationBlips: [
      {
        point:
          "Real-time biometric authentication using selfie and document match",
      },
      {
        point:
          "Detects impersonation, document tampering, and duplicate identities",
      },
      { point: "Built-in liveness detection prevents spoofing" },
    ],
    link: (
      <ArrowLink
        className="r2-verification-data__link"
        href="https://rent-id.io/sign-in"
        label={"Verify Your Renter"}
        target="_blank"
        icon={
          <ArrowRight
            className="r2-arrow-link__icon"
            style={{ color: "rgb(168 85 247)" }}
          />
        }
      />
    ),
    img: (
      <img
        src={verifyRequestImage}
        alt="Selfie and ID Verification Interface"
        className="r2-verification-data__image"
      />
    ),
  },
  {
    heading: "Driver's License Status",
    subHeading: "Confirm the renter’s license is valid.",
    link: (
      <ArrowLink
        className="r2-verification-data__link"
        href="https://rent-id.io/sign-in"
        label={"Validate Driver's License"}
        target="_blank"
        icon={
          <ArrowRight
            className="r2-arrow-link__icon"
            style={{ color: "rgb(168 85 247)" }}
          />
        }
      />
    ),
    verificationBlips: [
      {
        point: "Quickly validate a driver’s license with the state DMV",
      },
      { point: "Identify active, inactive or provisional license statuses" },
      { point: "Cost effective solution without purchasing a full MVR" },
    ],
    img: (
      <div className="r2-verification-data__license">
        <img
          src={licenseImage}
          alt="Insurance Verification Workflow"
          className="r2-verification-data__license-image"
        />
        <StatusIndicatorRow />
      </div>
    ),
  },
  {
    heading: "Renter Insurance Validation",
    subHeading:
      "Validate if the renter's personal auto insurance covers the vehicle.",
    link: (
      <ArrowLink
        className="r2-verification-data__link"
        href="https://rent-id.io/sign-in"
        label={"Validate Auto Insurance"}
        target="_blank"
        icon={
          <ArrowRight
            className="r2-arrow-link__icon"
            style={{ color: "rgb(168 85 247)" }}
          />
        }
      />
    ),
    verificationBlips: [
      { point: "Instant verification of active auto insurance policies" },
      { point: "Direct integration with major insurance providers" },
      { point: "Real-time coverage limit validation" },
      { point: "Credit card rental coverage validation" },
    ],
    img: (
      <div className="r2-verification-data__insurance">
        <img
          src={gradientRect}
          alt=""
          className="r2-verification-data__insurance-bg"
        />
        <video
          src={bookingVideo}
          muted
          playsInline
          loop
          autoPlay
          className="r2-verification-data__insurance-video"
        />
      </div>
    ),
  },
  {
    heading: "Criminal Record Check",
    subHeading:
      "Determine whether criminal activity is associated with the renter.",
    link: (
      <ArrowLink
        className="r2-verification-data__link"
        href="https://rent-id.io/sign-in"
        label={"Run Criminal Record Check"}
        target="_blank"
        icon={
          <ArrowRight
            className="r2-arrow-link__icon"
            style={{ color: "rgb(168 85 247)" }}
          />
        }
      />
    ),
    verificationBlips: [
      {
        point:
          "Criminal history check using state DMV and national data sources",
      },
      {
        point:
          "Reviews 400+ data points tied to the renter's identity and history",
      },
      {
        point:
          "Returns a clear result: criminal activity detected or not detected",
      },
    ],
    gradientBottom: true,
    img: <CriminalViolationsList />,
  },
  {
    heading: "Motor Vehicle Report (MVR)",
    subHeading: "Comprehensive and in-depth driving history report.",
    link: (
      <ArrowLink
        className="r2-verification-data__link"
        href="https://rent-id.io/sign-in"
        label={"Acces MVR"}
        target="_blank"
        icon={
          <ArrowRight
            className="r2-arrow-link__icon"
            style={{ color: "rgb(168 85 247)" }}
          />
        }
      />
    ),
    verificationBlips: [
      {
        point:
          "Complete violation history including tickets, accidents, and citations",
      },
      { point: "License status, points, suspensions, and restrictions" },
      { point: "DUI/DWI history and major traffic violations" },
    ],
    img: (
      <img
        src={mvrReportImage}
        alt="Motor Vehicle Report - DMV Building"
        className="r2-verification-data__mvr-image"
      />
    ),
  },
];
